/**
 * 政策筛选：最近 N 个年份（含今年），倒序
 * @param {number} count 年份数量，默认 6
 * @returns {{ id: string, name: string }[]}
 */
export function buildRecentYearOptions(count = 6) {
	const currentYear = new Date().getFullYear();
	const years = [];
	for (let i = 0; i < count; i++) {
		const y = String(currentYear - i);
		years.push({ id: y, name: y });
	}
	return years;
}

/**
 * 创新评估财务信息：从上一年起倒序 N 年（不含当年）
 * 例：2026 年 → ['2025','2024','2023']
 * @param {number} count 年份数量，默认 3
 * @returns {string[]}
 */
export function buildInnovationYearLabels(count = 3) {
	const startYear = new Date().getFullYear() - 1;
	const years = [];
	for (let i = 0; i < count; i++) {
		years.push(String(startYear - i));
	}
	return years;
}
